
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Button extends Vue {
  @Prop({ type: String, required: false, default: 'medium' }) public size!: string;
  @Prop({ type: String, required: false, default: 'green' }) public background!: string;
  @Prop({ type: String, required: false, default: 'white' }) public color!: string;
  @Prop({ type: String, required: false, default: 'white' }) public circleColor!: string;
  @Prop({ type: String, required: false, default: '' }) public icon!: string;
  @Prop({ type: String, required: false, default: 'Submit' }) public text!: string;
  @Prop({ type: Boolean, required: false, default: false }) public loading!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) public disabled!: boolean;
}
